"use strict";

exports.__esModule = true;
exports["default"] = exports.DisclaimerText = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _components = require("../../components");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DisclaimerText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "cover-band__DisclaimerText",
  componentId: "sc-jj7257-0"
})(["opacity:0.6;"]);
exports.DisclaimerText = DisclaimerText;
var propTypes = {
  /** String identifier for the currently active tab  */
  activeTab: _propTypes.string,

  /** alert Cta react node */
  alertCta: _propTypes.node,

  /** Back CTA Node */
  backToCta: _propTypes.node,

  /** Color string for gradient background color style */
  backgroundColor: _propTypes.string,

  /** String for background image */
  backgroundImage: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),

  /** Children node(s) to be rendered within the band container */
  children: _propTypes.node,

  /** array of flex direction for children */
  childrenAlign: (0, _propTypes.arrayOf)(_propTypes.string),

  /** Product chip image */
  chipImage: _propTypes.node,
  containerProps: (0, _propTypes.shape)({
    px: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.array])
  }),
  ctaStyle: (0, _propTypes.arrayOf)(_propTypes.string),

  /** Disclaimer text  */
  disclaimer: _propTypes.string,

  /** bool for is title includes os options dropdown */
  hasOsOptions: _propTypes.bool,

  /** array of alignment for header */
  headerAlign: (0, _propTypes.arrayOf)(_propTypes.string),

  /** array of direction for header */
  headerDirection: (0, _propTypes.arrayOf)(_propTypes.string),

  /** array of bool values for wrap */
  headerWrap: (0, _propTypes.arrayOf)(_propTypes.string),

  /** String to determine header tag */
  headingLevel: _propTypes.string,

  /** String for ID attribute */
  htmlId: _propTypes.string,

  /** Page title margin */
  margin: (0, _propTypes.arrayOf)(_propTypes.number),

  /** Callback to be called when active tab animation has ended */
  onTabChangeEnd: _propTypes.func,

  /** Callback to be called when tab is clicked */
  onTabClick: _propTypes.func,

  /** Tab components */
  tabs: (0, _propTypes.arrayOf)(_propTypes.object),

  /** Text alignment, defaults to right */
  textAlign: _propTypes.string,

  /** Text color, defaults to text-light */
  textColor: _propTypes.string,

  /** Page title */
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),

  /** Page title font */
  titleFont: (0, _propTypes.arrayOf)(_propTypes.number)
};
var coverBandWrapperStyle = {
  boxShadow: 3,
  flexDirection: "column"
};
var contentWrapperStyle = {
  flexDirection: ["column", "column", "row"],
  flexWrap: ["wrap", "wrap", "nowrap"],
  justifyContent: "flex-start",
  pb: 5,
  width: 1
};
var backToWrapperStyle = {
  flex: "0.5 1 auto",
  flexWrap: "wrap",
  width: [1, 1, "auto"]
};
var headerWrapperStyle = {
  alignItems: "center",
  width: 1
};
var chipImageStyle = {
  alignItems: "center",
  mb: [3, 3, 0],
  mr: [0, 0, 1],
  mt: 0
};
var titleWrapperStyle = {
  lineHeight: 2,
  mb: [3, 3, 0],
  mr: [0, 0, 2],
  width: 1
};
var titleFontStyle = {
  color: "gray-dark",
  fontWeight: 2
};
var disclaimerStyle = {
  fontSize: 0,
  mb: [2, 2, 0],
  width: 1
};
var childrenStyle = {
  flex: "0.5 1 auto",
  flexDirection: "column",
  justifyContent: "center",
  py: 0,
  style: {
    whiteSpace: "nowrap"
  },
  width: [1, 1, "auto"]
};
var alertCtaStyles = {
  display: ["flex"],
  justifyContent: ["center", "center", "flex-start"],
  mx: 2,
  position: "relative",
  top: "8px"
};

var CoverBand = function CoverBand(_ref) {
  var activeTab = _ref.activeTab,
      backToCta = _ref.backToCta,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? "background-dark" : _ref$backgroundColor,
      backgroundImage = _ref.backgroundImage,
      children = _ref.children,
      _ref$childrenAlign = _ref.childrenAlign,
      childrenAlign = _ref$childrenAlign === void 0 ? ["center", "center", "flex-end"] : _ref$childrenAlign,
      chipImage = _ref.chipImage,
      containerProps = _ref.containerProps,
      alertCta = _ref.alertCta,
      _ref$ctaStyle = _ref.ctaStyle,
      ctaStyle = _ref$ctaStyle === void 0 ? ["center", "flex-start"] : _ref$ctaStyle,
      disclaimer = _ref.disclaimer,
      _ref$hasOsOptions = _ref.hasOsOptions,
      hasOsOptions = _ref$hasOsOptions === void 0 ? false : _ref$hasOsOptions,
      headingLevel = _ref.headingLevel,
      htmlId = _ref.htmlId,
      _ref$headerDirection = _ref.headerDirection,
      headerDirection = _ref$headerDirection === void 0 ? ["column", "column", "row"] : _ref$headerDirection,
      _ref$headerWrap = _ref.headerWrap,
      headerWrap = _ref$headerWrap === void 0 ? ["wrap", "wrap", "nowrap"] : _ref$headerWrap,
      _ref$headerAlign = _ref.headerAlign,
      headerAlign = _ref$headerAlign === void 0 ? ["center", "center", "left"] : _ref$headerAlign,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? [0, 0, 2] : _ref$margin,
      onTabChangeEnd = _ref.onTabChangeEnd,
      onTabClick = _ref.onTabClick,
      tabs = _ref.tabs,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? "left" : _ref$textAlign,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? "text-light" : _ref$textColor,
      title = _ref.title,
      _ref$titleFont = _ref.titleFont,
      titleFont = _ref$titleFont === void 0 ? [8, 9, 10, 10] : _ref$titleFont;
  var alignHeader = ["center", "center", "flex-start"];
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, _extends({
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage,
    containerProps: containerProps,
    "data-test-id": "modules-cover-band",
    htmlId: htmlId
  }, coverBandWrapperStyle), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    mb: tabs ? 5 : 0,
    pt: backToCta ? 2 : 5
  }, contentWrapperStyle), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    justifyContent: ctaStyle
  }, backToWrapperStyle), backToCta, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    flexDirection: headerDirection,
    flexWrap: headerWrap,
    justifyContent: ["center", "center", "flex-start"]
  }, headerWrapperStyle), chipImage && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    "data-test-id": "modules-chip-image"
  }, chipImageStyle), chipImage), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    alignItems: alignHeader,
    flexDirection: "column"
  }, titleWrapperStyle), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    "data-test-id": "modules-cover-band-title",
    fontSize: hasOsOptions ? [8, 9, 10] : titleFont,
    letterSpacing: hasOsOptions ? ["0px", "0px", "-0.5px"] : "0px",
    lineHeight: hasOsOptions ? 2 : [2, 2, 1],
    mx: hasOsOptions || !chipImage ? 0 : margin,
    tag: headingLevel,
    textAlign: headerAlign
  }, titleFontStyle), title), alertCta && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, alertCtaStyles, alertCta))), disclaimer && /*#__PURE__*/_react["default"].createElement(DisclaimerText, _extends({
    color: textColor,
    mt: hasOsOptions || !chipImage ? 0 : margin,
    textAlign: ["center", "center", textAlign]
  }, disclaimerStyle), disclaimer)), children && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    alignItems: childrenAlign
  }, childrenStyle), children)), tabs && /*#__PURE__*/_react["default"].createElement(_components.Tabs, {
    activeTab: activeTab,
    items: tabs,
    onTabChangeEnd: onTabChangeEnd,
    onTabClick: onTabClick,
    position: "absolute"
  }));
};

CoverBand.propTypes = propTypes;
CoverBand.displayName = "Modules.CoverBand";
var _default = CoverBand;
exports["default"] = _default;